import { Component, OnInit, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';
import { TriggerEnum } from '../../models/trigger.enum';
import { ViewService } from 'src/app/view/view.service';
import { EngineState } from 'src/app/engine/state/engine.state';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { ScrollModeEnum } from 'src/app/engine/models/scroll-mode.enum';
import { map } from 'rxjs/operators';
import { ViewActions } from 'src/app/view/state/view.actions';

@Component({
  selector: 'app-view-tour-desktop',
  templateUrl: './view-tour-desktop.component.html',
  styleUrls: ['./view-tour-desktop.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewTourDesktopComponent implements OnInit {

  triggers = TriggerEnum;

  @Select(EngineState.getScrollMode)
  scrollMode$: Observable<ScrollModeEnum>;

  captureScroll$: Observable<boolean>;
  
  constructor(private viewService: ViewService) { }

  ngOnInit() {
    this.captureScroll$ = this.scrollMode$
      .pipe(
        map((mode) => mode === ScrollModeEnum.Capture)
    );
  }

  handleStartClick() {
    this.viewService.toggleTutorial(false);
  }

}
